import { combineReducers } from "redux";
import HomeReducer from "./HomeReducer";
import "bootstrap/dist/css/bootstrap.min.css";
import { entityReducer } from "clavis-nxt-components-custdevtm";

export default combineReducers({
  home: HomeReducer,
  entity: entityReducer
});
